import React, { useState } from 'react';

import { ErrorOutlineOutlined } from '@mui/icons-material';
import { Box, IconButton, Paper, Popper, type SxProps, Typography } from '@mui/material';

import { type WpRendererError } from '@waypoint/templates';

type Props = {
  error: WpRendererError;
};

const ICON_SX: SxProps = {
  position: 'absolute',
  top: 0,
  right: 0,
};

const ICON_BUTTON_SX = {
  borderRadius: 0,
  color: 'white',
  bgcolor: 'brand.red',
  '&:hover': {
    bgcolor: 'brand.red',
  },
};

const POPUP_SX: SxProps = {
  zIndex: 'tooltip',
};

const PAPER_SX: SxProps = {
  maxWidth: 200,
  p: 1,
};

export default function ErrorTooltip({ error }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
    setAnchorEl(anchorEl ? null : event.currentTarget.parentElement);
  };

  return (
    <>
      <Box sx={ICON_SX}>
        <IconButton size="small" sx={ICON_BUTTON_SX} onClick={handleClick}>
          <ErrorOutlineOutlined fontSize="small" />
        </IconButton>
      </Box>
      <Popper sx={POPUP_SX} open={isOpen} anchorEl={anchorEl} placement="bottom-start">
        <Paper sx={PAPER_SX}>
          <Typography variant="body2">{error.message}</Typography>
        </Paper>
      </Popper>
    </>
  );
}
